import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SearchInput from 'components/Form/SearchInput';
import {
  Container,
  Header,
  Tabs,
  Tab,
  SearchInputContainer,
  BrandSelect,
  Loader,
} from './styles';
import Table from './Table';
import Detail from './Detail';
import useConnect from './connect';

const Orders: FC = () => {
  const {
    search,
    setSearch,
    orders,
    selectedBrandId,
    setSelectedBrandId,
    isLoadingOrders,
    isSearching,
  } = useConnect();

  return (
    <>
      {isLoadingOrders && <Loader />}
      <Container>
        <Header>
          <Tabs>
            <Tab
              label="Active"
              extraInfo={`(${orders.active.length})`}
              to="/orders/active"
            />
            <Tab
              label="Completed"
              extraInfo={`(${orders.completed.length})`}
              to="/orders/completed"
            />
            <Tab
              label="Scheduled"
              extraInfo={`(${orders.scheduled.length})`}
              to="/orders/scheduled"
            />
            <Tab
              label="Cancelled"
              extraInfo={`(${orders.cancelled.length})`}
              to="/orders/cancelled"
            />
          </Tabs>

          <BrandSelect
            value={selectedBrandId}
            allowAllOption
            setSelectedId={setSelectedBrandId}
          />

          <SearchInputContainer>
            <SearchInput value={search} onChangeValue={setSearch} />
          </SearchInputContainer>
        </Header>

        <Switch>
          <Route exact path="/orders/active">
            <Table
              orders={orders.active}
              isLoading={isLoadingOrders}
              tabName="active"
              isSearching={isSearching}
            />
          </Route>
          <Route exact path="/orders/completed">
            <Table
              orders={orders.completed}
              isLoading={isLoadingOrders}
              tabName="completed"
              isSearching={isSearching}
            />
          </Route>
          <Route exact path="/orders/scheduled">
            <Table
              orders={orders.scheduled}
              isLoading={isLoadingOrders}
              tabName="scheduled"
              isSearching={isSearching}
            />
          </Route>
          <Route exact path="/orders/cancelled">
            <Table
              orders={orders.cancelled}
              isLoading={isLoadingOrders}
              tabName="cancelled"
              isSearching={isSearching}
            />
          </Route>
          <Route path="/orders/:orderId" component={Detail} />
          <Redirect to="/orders/active" />
        </Switch>
      </Container>
    </>
  );
};

export default Orders;
